import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SortService {

  subject = new Subject<any>();

  constructor() { }

  get Filter(): Observable<any> {
    return this.subject.asObservable();
  }

  Sorted(Message: any) {
    this.subject.next(Message);
  }

  Reset() {
    this.Sorted({Reset: true});
  }

  sortByField(array: any[], field: string, asc: number = 1, map: (o: any) => any = o => o) {
    array.sort((a, b) => {
      let mapA = map(a);
      let mapB = map(b);
      let am = mapA == null ? null : mapA[field];
      let bm = mapB == null ? null : mapB[field];
      if (typeof am === 'string') {
        am = am.toLowerCase();
      }
      if (typeof bm === 'string') {
        bm = bm.toLowerCase();
      }
      if (!am && !bm) {
        return 0;
      } else if (!am) {
        return 1 * asc;
      } else if (!bm) {
        return -1 * asc;
      } else if (am === bm) {
        return 0;
      }
      return am > bm ? 1 * asc : -1 * asc;
    });
  }

  sortByBooleanField(array: any[], field: string, asc: number = 1, map: (o: any) => any = o => o) {
    array.sort((a, b) => {
      let mapA = map(a);
      let mapB = map(b);
      let am = mapA == null ? null : mapA[field];
      let bm = mapB == null ? null : mapB[field];
      if (am == null && bm == null) {
        return 0;
      } else if (am == null) {
        return 1 * asc;
      } else if (bm == null) {
        return -1 * asc;
      } else if (am === bm) {
        return 0;
      }
      return am ? 1 * asc : -1 * asc;
    });
  }
}
